/**
 * Debug utilities for logging and debugging across the application
 */

export const addDebugLog = (message, type = 'info') => {
  const timestamp = new Date().toLocaleTimeString();
  const logMessage = `[${timestamp}] ${message}`;
  
  switch (type) {
    case 'success':
      console.log('%c' + logMessage, 'color: green; font-weight: bold;');
      break;
    case 'error':
      console.error('%c' + logMessage, 'color: red; font-weight: bold;');
      break;
    case 'warning':
      console.warn('%c' + logMessage, 'color: orange; font-weight: bold;');
      break;
    case 'info':
    default:
      console.log('%c' + logMessage, 'color: blue; font-weight: bold;');
      break;
  }
};

export default { addDebugLog };
